import type {RouteLocationNormalized} from 'vue-router'
import {isStackableRoute} from '@toolify/client/src/setup/router/hooks/isStackableOverlayNavigation'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {WorkspaceTabKindType} from '@toolify/client/src/modules/workspaceTabs/enum/WorkspaceTabKindType'
import {IWorkspaceTab} from '@toolify/client/src/modules/workspaceTabs/types/IWorkspaceTab'
import {getRouteParamRecord} from '@toolify/client/src/modules/workspaceTabs/functions/getRouteParamRecord'
import {getResourceWorkspaceTabKey} from '@toolify/client/src/modules/workspaceTabs/functions/getResourceWorkspaceTabKey'
import {getRouteWorkspaceTabKey} from '@toolify/client/src/modules/workspaceTabs/functions/getRouteWorkspaceTabKey'

const routeTabNames = new Set<RouteName>([
  RouteName.WorkspaceHome,
  RouteName.WorkspaceResources,
  RouteName.WorkspaceResourceCollection,
  RouteName.Collections,
  RouteName.Collection,
  RouteName.CollectionRecents,
])

const nonTabbableNamePattern = /(settings|permissions|activity|webhooks|links|trash|watcher|notification|file)/i

function isTabbableRouteName(name: unknown): name is RouteName {
  if(typeof name !== 'string') {
    return false
  }
  return !nonTabbableNamePattern.test(name)
}

export function getTabFromRoute(route: RouteLocationNormalized): IWorkspaceTab | null {
  if(isStackableRoute(route)) {
    return null
  }
  if(!isTabbableRouteName(route.name)) {
    return null
  }
  const params = getRouteParamRecord(route.params)
  const routeResource = route.meta.determineResource?.(route) ?? null
  if(routeResource) {
    return {
      key: getResourceWorkspaceTabKey(routeResource.resourceType, routeResource.resourceId),
      kind: WorkspaceTabKindType.Resource,
      name: route.name as RouteName,
      params,
      resourceType: routeResource.resourceType,
      resourceId: routeResource.resourceId,
    }
  }
  if(!routeTabNames.has(route.name)) {
    return null
  }
  return {
    key: getRouteWorkspaceTabKey(route.name, params),
    kind: WorkspaceTabKindType.Route,
    name: route.name as RouteName,
    params,
  }
}
